// eslint-disable-next-line no-shadow
export enum FormInputFilterEvent {
  filterSearch = 'filterSearch',
  inputSearch = 'inputSearch',
}
